<template>
  <CardCollapse :title="$t('global.advanced-auto-scaling-usage-details')">
    <CardTabledList :items="getItems()" />
  </CardCollapse>
</template>

<script>
import CardCollapse from "@/components/display/card-sub-components/CardCollapse";
import CardTabledList from "@/components/display/card-sub-components/CardTabledList";
import { moneyFormat } from "leatherman-js/utils/formatters/money";

export default {
  name: "AdvancedAutoScaleUsage",
  props: {
    advancedAutoScale: {
      type: Object,
      required: true,
    },
  },
  components: {
    CardCollapse,
    CardTabledList,
  },
  setup(props, { root }) {
    const getItems = () => {
      const baseContainers = props.advancedAutoScale.addon.baseQuantity.containers;
      const baseCost = props.advancedAutoScale.usage.baseCost;
      const cost = moneyFormat(props.advancedAutoScale.usage.cost);

      const getAddonContainersInfo = (autoScale) => {
        const addonContainers = Math.max(autoScale.addon.quantity.containers - baseContainers, 0);
        const additionalHoursPrice = autoScale.usage.additionalHoursPrice;
        const additionalDaysCost = additionalHoursPrice * 24;
        const totalWorkers =
          addonContainers * props.advancedAutoScale.addon.quantity.workersPerContainer;

        const addonContainerDailyCost = root
          .$t("global.advanced-auto-scaling-usage-addon-container-daily-rate", {
            price: moneyFormat(additionalDaysCost * addonContainers),
          })
          .toLowerCase();

        const addonContainersDisplay = root
          .$t("global.advanced-auto-scale-containers", {
            containers: addonContainers,
          })
          .toLowerCase();

        const workers = root
          .$t("global.advanced-auto-scale-workers", { workers: totalWorkers })
          .toLowerCase();

        return `${addonContainerDailyCost} (${addonContainersDisplay}, ${workers})`;
      };

      const getBaseContainersInfo = () => {
        const totalWorkers =
          props.advancedAutoScale.addon.baseQuantity.containers *
          props.advancedAutoScale.addon.baseQuantity.workersPerContainer;

        const containers = root
          .$t("global.advanced-auto-scale-containers", { containers: baseContainers })
          .toLowerCase();

        const workers = root
          .$t("global.advanced-auto-scale-workers", { workers: totalWorkers })
          .toLowerCase();

        return `${moneyFormat(baseCost)} (${containers}, ${workers})`;
      };

      const getBilledTimeInfo = (usage) => {
        const billedTimeAmount = moneyFormat(
          usage?.additionalHoursPrice * usage?.additionalHoursUsed
        );

        const billedHours = usage?.additionalHoursUsed;

        const billedHoursDisplay = root
          .$t("global.advanced-auto-scaling-usage-billed-time", { hours: billedHours })
          .toLowerCase();

        return `${billedTimeAmount} (${billedHoursDisplay})`;
      };

      return [
        {
          key: root.$t("global.advanced-auto-scaling-usage-base-containers"),
          value: getBaseContainersInfo(props.advancedAutoScale.addon),
        },
        {
          key: root.$t("global.advanced-auto-scaling-usage-addon-containers"),
          value: getAddonContainersInfo(props.advancedAutoScale),
        },
        {
          key: root.$t("global.advanced-auto-scaling-usage-estimated-billed-time"),
          value: getBilledTimeInfo(props.advancedAutoScale.usage),
        },
        {
          key: root.$t("global.advanced-auto-scaling-usage-estimated-amount"),
          value: cost,
        },
      ];
    };

    return {
      getItems,
    };
  },
};
</script>
